import React, { useEffect, useState } from "react";
import { Flex, Button, Text } from "@appsmith/ads";
import { createMessage, IN_APP_EMBED_SETTING } from "ee/constants/messages";
import { getAgentChatQueries } from "ee/selectors/aiAgentSelectors";
import { useSelector } from "react-redux";

const CHROME_EXTENSION_URL =
  "https://chromewebstore.google.com/detail/appsmith-agents/mlmnoikcaeggnjijgimjbiojaeeeifal";

export function ChromeExtensionBanner() {
  const agentsQueries = useSelector(getAgentChatQueries);
  const isAgentsApp = agentsQueries.length > 0;
  const [chromeExtensionConfig, setChromeExtensionConfig] = useState<{
    [key: string]: string | undefined;
  }>({});

  useEffect(function checkChromeExtensionInstallation() {
    window.postMessage({ type: "PING_APPSMITH_AGENT_EXTENSION" });

    window.addEventListener("message", (event) => {
      if (event.data.type === "PONG_APPSMITH_AGENT_EXTENSION") {
        setChromeExtensionConfig({
          ...chromeExtensionConfig,
          ...event.data,
        });
      }
    });

    setTimeout(() => {
      if (!chromeExtensionConfig.extensionId) {
        setChromeExtensionConfig({});
      }
    });
  }, []);

  if (!isAgentsApp) return null;

  return (
    <Flex flexDirection="column" gap="spaces-2">
      <>
        <Text kind="body-m">
          {createMessage(
            IN_APP_EMBED_SETTING.chromeExtensionBannerTitle,
            Boolean(chromeExtensionConfig.extensionId),
          )}
        </Text>
        <Flex alignItems="center" justifyContent="space-between">
          <Text color="var(--ads-v2-color-fg-muted)" kind="body-s">
            {createMessage(
              IN_APP_EMBED_SETTING.chromeExtensionBannerDescription,
            )}
          </Text>

          <Button
            endIcon="share-box-line"
            href={
              chromeExtensionConfig.extensionId
                ? `chrome-extension://${chromeExtensionConfig.extensionId}/src/options/options.html`
                : CHROME_EXTENSION_URL
            }
            kind="primary"
            onClick={(e) => {
              if (chromeExtensionConfig.extensionId) {
                e.preventDefault();

                postMessage({
                  type: "OPEN_APPSMITH_AGENTS_EXTENSION",
                });
              }
            }}
            renderAs="a"
            target="_blank"
          >
            {createMessage(
              IN_APP_EMBED_SETTING.chromeExtensionBannerButton,
              Boolean(chromeExtensionConfig.extensionId),
            )}
          </Button>
        </Flex>
      </>
    </Flex>
  );
}
